import { IAnyNode, ISelectableNode } from '../types';
import React from 'react';
import CreatableNode from './CreatableNode';
import EntityNode from './EntityNode';
import BranchNode from './BranchNode';
import InlineBranchNode from './InlineBranchNode';
import {
  isBranchNode,
  isCreatableNode,
  isEntityNode,
  isInlineBranchNode,
  isPresentationNode,
} from '../utils';
import { UnreachableCaseError } from 'ts-essentials';
import ThinDivider from '../../../ThinDivider';

interface IProps {
  indent: number;
  node: IAnyNode;
  onSelectNode: (node: ISelectableNode) => void;
  selectedNode: ISelectableNode;
}

const AnyNode = ({ node, onSelectNode, selectedNode, indent }: IProps) => {
  if (isBranchNode(node)) {
    return (
      <BranchNode
        selectedNode={selectedNode}
        onSelectNode={onSelectNode}
        node={node}
        indent={indent}
      />
    );
  }
  if (isInlineBranchNode(node)) {
    return (
      <InlineBranchNode
        node={node}
        selectedNode={selectedNode}
        onSelectNode={onSelectNode}
        indent={indent}
      />
    );
  } else if (isCreatableNode(node)) {
    return (
      <CreatableNode selectedNode={selectedNode} node={node} indent={indent} />
    );
  } else if (isPresentationNode(node)) {
    return <ThinDivider layout="horizontal" size="full" />;
  } else if (isEntityNode(node)) {
    return (
      <EntityNode
        node={node}
        onSelectNode={onSelectNode}
        selectedNode={selectedNode}
        indent={indent}
      />
    );
  } else {
    throw new UnreachableCaseError(node);
  }
};
export default AnyNode;
